import withStore, { TPresentable, TLoadingAwarePresenter } from "../withStore";
import Application from "../../Application";
import { IPaymentInstruction } from "../../model/payment/PaymentInstruction";
import PaymentInstructionPresentationModel, {
  TPaymentInstructionPresentationModel
} from "./model/PaymentInstructionPresentationModel";
import SaveLanguageToStorageInteractor from "../../interactor/credential/SaveLanguageToStorageInteractor";
import { UserPreferences } from "../../common/Constants";

export interface TPaymentInstructionPresenter extends TLoadingAwarePresenter {
  paymentInstruction: TPaymentInstructionPresentationModel;
  languageCode: string;
}

export interface IPaymentInstructionPresenter
  extends TPaymentInstructionPresenter,
    TPresentable {
  setInstruction(paymentInstruction: IPaymentInstruction): void;
  changeLanguage(languageCode: string): void;
  setLanguageCode(languageCode: string): void;
}

const defaultState: TPaymentInstructionPresenter = {
  paymentInstruction: {} as TPaymentInstructionPresentationModel,
  languageCode: UserPreferences.DEFAULT_LANGUAGE
};

const PaymentConfirmationPresenter = withStore<
  IPaymentInstructionPresenter,
  TPaymentInstructionPresenter
>(({ application, store, loader, translate }): IPaymentInstructionPresenter => {
  const _store = store;
  const _application: Application = application;
  const state = _store.getState<
    TPaymentInstructionPresenter & TLoadingAwarePresenter
  >();

  loader.start("paymentInstructionLoader");

  const setInstruction = (paymentInstruction: IPaymentInstruction) => {
    _store.update({
      paymentInstruction: PaymentInstructionPresentationModel(
        paymentInstruction
      )
    });
    loader.stop("paymentInstructionLoader");
  };

  const setLanguageCode = (languageCode: string) => {
    _store.update({
      languageCode
    });
  };

  const changeLanguage = async (languageCode: string) => {
    setLanguageCode(languageCode);

    _application.container.registerValue("language", languageCode);

    await _application.container
      .resolve<SaveLanguageToStorageInteractor>("saveLanguageToStorage")
      .execute(languageCode);
  };

  return {
    ...state,

    store: _store,
    loader,
    application: _application,
    translate,
    setInstruction,
    changeLanguage,
    setLanguageCode
  };
}, defaultState);

export default PaymentConfirmationPresenter;
